"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _nicbaseDialogs = require("nicbase-dialogs");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _carousel = _interopRequireDefault(require("./carousel"));

var _widgetSelectorButton = _interopRequireDefault(require("./widget-selector-button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var orderBySort = function orderBySort(entries) {
  return entries.sort(function (a, b) {
    if (typeof a.sort === 'undefined' && typeof b.sort === 'undefined') return 0;
    if (typeof a.sort === 'undefined') return 1;
    if (typeof b.sort === 'undefined') return -1;
    return a.sort - b.sort;
  });
};

var calculateSiteSize = function calculateSiteSize(width, height) {
  var siteSize = 8;

  if (height <= 640) {
    // one row
    siteSize = 4;

    if (width <= 1660) {
      siteSize = 3;
    }

    if (width <= 1280) {
      siteSize = 2;
    }

    if (width <= 880) {
      siteSize = 1;
    }
  } else {
    // two rows
    if (width <= 1800) {
      siteSize = 6;
    }

    if (width <= 1400) {
      siteSize = 4;
    }

    if (width <= 1000) {
      siteSize = 2;
    }

    if (width <= 600) {
      siteSize = 1;
    }
  }

  return siteSize;
};

var AddNewWidgetDialog = function AddNewWidgetDialog(_ref) {
  var active = _ref.active,
      closeDialog = _ref.closeDialog;

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var _useState = (0, _react.useState)(window.innerWidth),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  var _useState3 = (0, _react.useState)(window.innerHeight),
      _useState4 = _slicedToArray(_useState3, 2),
      height = _useState4[0],
      setHeight = _useState4[1]; // request to load widget types


  var _usePortalWidgetTypes = (0, _hooks.usePortalWidgetTypes)({
    portalId: portalId,
    options: {
      select: orderBySort
    }
  }),
      widgetTypes = _usePortalWidgetTypes.data;

  var updateWindowDimensions = (0, _react.useCallback)(function () {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  }, []); // add and remove resize event listener

  (0, _react.useEffect)(function () {
    updateWindowDimensions();
    window.addEventListener('resize', updateWindowDimensions);
    return function () {
      window.removeEventListener('resize', updateWindowDimensions);
    };
  }, [updateWindowDimensions]);
  var selectButtons = (0, _react.useMemo)(function () {
    var siteSize = calculateSiteSize(width, height);
    var buttons = [];

    for (var index = 0; index < (widgetTypes === null || widgetTypes === void 0 ? void 0 : widgetTypes.length); index += siteSize) {
      var typesForSite = widgetTypes.slice(index, index + siteSize);
      buttons.push(typesForSite.map(function (type) {
        return /*#__PURE__*/_react["default"].createElement(_widgetSelectorButton["default"], {
          key: type.id,
          onClick: function onClick() {
            return closeDialog(type.id);
          },
          type: type
        });
      }));
    }

    return buttons;
  }, [closeDialog, widgetTypes, height, width]);
  return /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog, {
    active: active,
    className: "w-1/2"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog.Header, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.add"
    })
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog.Body, {
    className: "overflow-x-hidden"
  }, /*#__PURE__*/_react["default"].createElement(_carousel["default"], {
    container: selectButtons
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog.Footer, null, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    primary: true,
    onClick: function onClick() {
      return closeDialog();
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.cancel"
  }))));
};

AddNewWidgetDialog.propTypes = {
  active: _propTypes["default"].bool,
  closeDialog: _propTypes["default"].func
};

var noop = function noop() {};

AddNewWidgetDialog.defaultProps = {
  active: false,
  closeDialog: noop
};
var _default = AddNewWidgetDialog;
exports["default"] = _default;